import { getIssuer } from 'modules/creditCard';
import useBillingPaymentMake from 'modules/queries/billing/payment/useMake';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import ConfirmPaymentContent from './ConfirmPayment';

const ConfirmOneTimePaymentContent = () => {
	const { formValues, opaqueData, onSubmitSuccess, onSubmitError } =
		useDialogMakePaymentContext();
	const { mutate: makePayment, isLoading: isMakingPayment } =
		useBillingPaymentMake();

	const { amount, cardNumber, expirationDate } = formValues;
	const issuer = getIssuer(cardNumber) || '';
	const maskedCcNumber = cardNumber.slice(-4);

	const handleSubmit = () => {
		if (!opaqueData) {
			// should never happen but just in case...
			onSubmitError();
			return;
		}

		makePayment(
			{
				amount,
				opaque_data: opaqueData,
			},
			{
				onSuccess: onSubmitSuccess,
				onError: onSubmitError,
			},
		);
	};

	return (
		<ConfirmPaymentContent
			amount={Number(amount)}
			paymentMethod="credit_card"
			onSubmit={handleSubmit}
			issuer={issuer}
			maskedCcNumber={maskedCcNumber}
			ccExpiration={expirationDate}
			isSubmitting={isMakingPayment}
		/>
	);
};

export default ConfirmOneTimePaymentContent;
